module.exports = {
          srcSet: __webpack_public_path__ + "745fb6906d8fd87dc29f25eb1d4b81ff-150.png"+" 150w",
          images:[ {path: __webpack_public_path__ + "745fb6906d8fd87dc29f25eb1d4b81ff-150.png",width: 150,height: 45}],
          src: __webpack_public_path__ + "745fb6906d8fd87dc29f25eb1d4b81ff-150.png",
          toString:function(){return __webpack_public_path__ + "745fb6906d8fd87dc29f25eb1d4b81ff-150.png"},
          
          width: 150,
          height: 45
        }